import React from 'react';
import './Impressum.css'; // CSS für das Impressum

const Impressum = ({
  companyName,
  streetAddress,
  postalCodeCity,
  phone,
  fax,
  email,
  responsiblePerson,
  managingDirector,
  vatId,
  registerNumber,
  registerCourt,
  imageSources,
  designAgency,
  agbLink,
  dataPrivacyLink,
  disputeResolutionLink
}) => (
  <div className="impressum-container">
    <h1>Impressum</h1>
    <p>{companyName}</p>
    <p>{streetAddress}</p>
    <p>{postalCodeCity}</p>

    <p>Telefon: {phone}</p>
    <p>Telefax: {fax}</p>
    <p>E-Mail: <a href={`mailto:${email}`}>{email}</a></p>

    <p>Inhaltlich verantwortlich gemäß § 6 MDStV: {responsiblePerson}</p>
    <p>Vertretungsberechtigter Geschäftsführer: {managingDirector}</p>
    <p>UmSt-IdNr.: {vatId}</p>
    <p>Registernummer: {registerNumber}</p>
    <p>Registergericht: {registerCourt}</p>

    <p>Handwerksordnung: <a href="https://www.gesetze-im-internet.de/hwo/index.html" target="_blank" rel="noopener noreferrer">HwO – nichtamtliches Inhaltsverzeichnis</a></p>

    <p>Konzeption, Grafik und Text: <a href={designAgency.url} target="_blank" rel="noopener noreferrer">{designAgency.name}</a></p>
    <p>Bildquellen: {imageSources.join(', ')}</p>

    <h2>Haftungsausschluss</h2>
    <p>
      Alle Informationen und sonstigen Angaben auf dieser Website sind unverbindlich und unterliegen dem Vorbehalt der jederzeitigen Änderung.
      Jede Haftung für die Richtigkeit und Vollständigkeit der Informationen ist ausgeschlossen. Alle auf unseren Internetseiten veröffentlichten
      Informationen wurden nach bestem Wissen und Gewissen erstellt. Trotzdem gelten diese als unverbindlich und bilden keinerlei Rechtsansprüche
      insbesondere nicht für unmittelbare oder mittelbare Folgeschäden.
    </p>

    <h2>Haftungsausschluss für Hyperlinks</h2>
    <p>
      Bei den angelinkten Partner-Seiten handelt es sich ausschließlich um fremde Inhalte. Der Anbieter {companyName} hat keinerlei Einfluss auf den
      Inhalt und distanziert sich ausdrücklich und übernimmt daher keinerlei Verantwortung für den Inhalt der angelinkten Seiten.
    </p>

    <h2>Urheberschutz</h2>
    <p>
      Der gesamte Inhalt dieser Website ist urheberrechtlich geschützt. Weitergabe, Veränderung, gewerbliche Nutzung, Vervielfältigung,
      Übermittlung, Veränderung oder Verwendung auf anderen Webseiten, Herunterladen von Daten, insbesondere von Fotos etc., ist untersagt.
    </p>

    <h2>Allgemeines</h2>
    <p>
      Für die Ausführung und Abwicklung von Aufträgen gelten unsere <a href={agbLink} target="_blank" rel="noopener noreferrer">Allgemeinen Geschäftsbedingungen</a>,
      die Ihnen auf Wunsch zugestellt werden.
    </p>

    <h2>Datenschutz</h2>
    <p>siehe im Menü unter <a href={dataPrivacyLink} target="_blank" rel="noopener noreferrer">Datenschutz</a>.</p>

    <h2>Alternative Streitbeilegung</h2>
    <p>
      Plattform der EU-Kommission zur Online-Streitbeilegung: <a href={disputeResolutionLink} target="_blank" rel="noopener noreferrer">{disputeResolutionLink}</a>
      Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle weder verpflichtet noch bereit.
    </p>
  </div>
);

export default Impressum;
